<div style="margin-top: 20px;" (window:resize)="onResize($event)">
    <div class="container">
        <div class="header-img" (click)="goHome();" *ngIf="!hideImg">
          <img src="https://www.panetworkscotland.org.uk/images/panetwork-logo.png" alt="200x200" width="300px" height="130px">
        </div>
        <div class="container-header">
          <h1>PA Network: Badge (Free Offer)</h1>
        </div>
        <div class="container-header checkout-btn">
            <a routerLink="/checkout">
              <button mat-raised-button
                matBadge="{{ badgeNumber }}" matBadgePosition="before" matBadgeColor="accent" (click)="changeMe()">
                <mat-icon>shopping_basket</mat-icon><span> Basket</span>
              </button>
            </a>
        </div>
    </div>
    <div>
      <!-- The routed views render in the <router-outlet>-->
      <router-outlet></router-outlet>
    </div>
</div>




